<template>
  <div class="term-topics-section">
    <!-- TOP ACCORDION -->
    <div
      class="top-accordion brand_inverse_light_bg pointer"
      @click="toggleTopicList"
    >
      <div class="term-text text-capitalize brand_primary font-weight-bold">
        {{ term_title }} Term
      </div>

      <div class="avatar">
        <span
          class="color_ash flex-center"
          :class="show_topics ? caret_down : caret_up"
        ></span>
      </div>
    </div>

    <!-- BOTTOM ACCORDION -->
    <div
      class="bottom-accordion position-relative"
      v-if="show_topics"
      @dragover="cardDraggedOver"
      @drop="dropTopicCard($event)"
    >
      <template v-if="!loading">
        <template v-if="topic_list.length">
          <div class="topic-card-list">
            <TopicCardRow
              :topic_id="Number(topic.id)"
              :topic_data_id="Number(topic.topic_id)"
              :topic_title="topic.topic"
              :is_custom="Number(topic.is_custom)"
              :learning_area="topic.learningArea"
              :term_topic_id="term_title + '_' + index"
              v-for="(topic, index) in topic_list"
              :key="index"
            />
          </div>
          <div class="position-relative">
            <TopicEntryRow
              @showCreateTopicModal="toggleCreateTopic"
              @showTopicSearch="toggleTopicSearch"
            />
            <div class="position-absolute w-100">
              <TopicSearch
                :term="term_title"
                v-if="show_search"
                @close-search-topic="toggleTopicSearch"
              />
            </div>
          </div>
        </template>

        <template v-else>
          <div
            class="topic-card-list py-3 text-center color_ash empty-drop-box rounded-5 mb-3"
            :id="term_title"
          >
            You can drop a topic here
          </div>

          <div class="position-relative">
            <EmptyTopicList
              @showCreateTopicModal="toggleCreateTopic"
              @showTopicSearch="toggleTopicSearch"
            />
            <div class="empty-topic-section position-absolute w-100">
              <TopicSearch
                :term="term_title"
                v-if="show_search"
                @close-search-topic="toggleTopicSearch"
              />
            </div>
          </div>
        </template>
      </template>
    </div>

    <!-- MODAL -->
    <CreateTopicModal
      :subject_id="current_subject.id"
      :subject_name="current_subject.name"
      :term="term_title"
      v-if="create_topic"
      @closeTriggered="toggleCreateTopic"
    />
    <!-- MODAL -->
  </div>
</template>

<script>
export default {
  name: "TopicListByTerm",

  components: {
    TopicCardRow: () =>
      import(
        /* webpackChunkName: "TopicCardRow" */ "@/components/globalComps/SettingsComps/SubjectComps/TopicCardRow"
      ),
    TopicEntryRow: () =>
      import(
        /* webpackChunkName: "TopicEntryRow" */ "@/components/globalComps/SettingsComps/SubjectComps/TopicEntryRow"
      ),
    EmptyTopicList: () =>
      import(
        /* webpackChunkName: "EmptyTopicList" */ "@/components/globalComps/SettingsComps/SubjectComps/EmptyTopicList"
      ),
    TopicSearch: () =>
      import(
        /* webpackChunkName: "TopicSearch" */ "@/components/globalComps/SettingsComps/SubjectComps/TopicSearch"
      ),
    CreateTopicModal: () =>
      import(
        /* webpackChunkName: "CreateTopicModal" */
        "@/components/modalComps/settingsModals/CreateTopicModal"
      ),
  },

  props: {
    current_subject: Object,
    term_title: String,
    topic_list: Array,
    loading: Boolean,
  },

  computed: {},

  data() {
    return {
      show_topics: true,
      show_search: false,
      create_topic: false,
      caret_down: "icon-caret-down font-10",
      caret_up: "icon-caret-up font-22",
      offset_box: 0,
      drop_topic: null,
    };
  },

  methods: {
    toggleTopicList() {
      this.show_topics = !this.show_topics;
    },

    toggleCreateTopic() {
      this.create_topic = !this.create_topic;
    },

    toggleTopicSearch() {
      this.show_search = !this.show_search;
    },

    dropTopicCard(e) {
      let from = e.dataTransfer.getData("Topic");
      this.$bus.$emit("event-bus-topic-drop", {
        from,
        to: this.drop_topic,
        offset: this.offset_box,
      });
      // console.log("from", from);
      // console.log("to", term_id);
    },

    cardDraggedOver($event) {
      $event.preventDefault();
      let box = $event.target.getBoundingClientRect();
      this.offset_box = $event.clientY - box.top - box.height / 2;
      this.drop_topic = $event.target.getAttribute("id");
    },
  },
};
</script>

<style lang="scss" scoped>
.term-topics-section {
  &:nth-of-type(2) {
    margin-top: 4px;
    margin-bottom: 2px;
  }
  &:last-of-type {
    margin-top: 2.5px;
    margin-bottom: 0;
  }
  .top-accordion {
    padding: 17px 30px;
    @include flex_row_between_nowrap;
    transition: all 0.4s ease-in-out;

    @include breakpoint_max(lg) {
      padding: 17px 20px;
    }
    @include breakpoint_max(xs) {
      padding: 17px 15px;
    }

    &:hover {
      background: $brand_accent_light !important;
    }

    .term-text {
      font-size: 15px;
      line-height: 22px;

      @include breakpoint_max(lg) {
        font-size: 13px;
      }
    }

    .avatar {
      @include equal_min_edge(24);
    }
  }

  .bottom-accordion {
    padding: 16px 30px;
    transition: all 0.6s ease-in-out;

    @include breakpoint_max(lg) {
      padding: 17px 20px;
    }
    @include breakpoint_max(xs) {
      padding: 17px 15px;
    }
    // animation: panel-slide-down 0.5s ease-in-out forwards;
    // animation: panel-slide-up 0.5s ease-in-out forwards;
  }

  .empty-topic-section {
    top: 140px;
  }

  .empty-drop-box {
    border: 1px dashed $border_grey;
    font-size: 13px;
    line-height: 15px;
    background: $color_white;
  }
}
</style>
